import React from "react";
import { BookOpen, Users, Lightbulb, Globe, Target, Award } from "lucide-react";
import { useNavigate } from "react-router-dom";
import {AboutUsSvg2} from "../config.js";
const AboutUs = () => {
  const navigate = useNavigate();
  return (
    <div className="pt-12">
      {/* Hero Section */}
      <div className="relative h-[500px] overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="./AboutUsSvg1.svg"
            alt="UPSC preparation"
            className="w-full h-full object-scale-down"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/50"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="text-white max-w-3xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              Welcome to the Future of UPSC Preparation
            </h1>
            <p className="text-xl md:text-2xl leading-relaxed">
              In a world where UPSC exam preparation can feel like navigating a
              labyrinth, CIVILSCODE emerges as a beacon of innovation and
              simplicity.
            </p>
          </div>
        </div>
      </div>

      {/* What We Offer Section */}
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900">
              The CIVILSCODE Arsenal
            </h2>
            <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
              Dive into our comprehensive suite of tools and resources designed
              to transform your UPSC preparation journey.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="flex items-center justify-center w-16 h-16 bg-[#77c36f] rounded-2xl mb-6">
                <BookOpen className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-4">NCERT Simplified</h3>
              <p className="text-gray-600">
                Your compass in the vast ocean of the UPSC syllabus,
                meticulously crafted to provide clear, concise understanding.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="flex items-center justify-center w-16 h-16 bg-[#77c36f] rounded-2xl mb-6">
                <Lightbulb className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-4">360° Notes</h3>
              <p className="text-gray-600">
                Comprehensive coverage ensuring no aspect of your preparation is
                left unexplored, all in one unified platform.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="flex items-center justify-center w-16 h-16 bg-[#77c36f] rounded-2xl mb-6">
                <Target className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-4">
                Content Personalization
              </h3>
              <p className="text-gray-600">
                Revolutionary technology that adapts study material to your
                unique learning style and preferences.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Our Edge Section */}
      <div className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                The CIVILSCODE Difference
              </h2>
              <p className="text-xl text-gray-600 mb-8">
                Standing tall as the sole beacon in India for smart, simplified
                notes complemented by on-site content personalization,
                CIVILSCODE is not just a study platform; it's a revolution.
              </p>
              <div className="space-y-8">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center w-12 h-12 bg-[#77c36f]/10 rounded-xl">
                      <Award className="h-6 w-6 text-[#77c36f]" />
                    </div>
                  </div>
                  <div className="ml-4">
                    <h4 className="text-lg font-semibold">
                      Technological Prowess
                    </h4>
                    <p className="mt-2 text-gray-600">
                      Setting new standards with innovative features and
                      personalized learning experiences.
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center w-12 h-12 bg-[#77c36f]/10 rounded-xl">
                      <Globe className="h-6 w-6 text-[#77c36f]" />
                    </div>
                  </div>
                  <div className="ml-4">
                    <h4 className="text-lg font-semibold">Anywhere Access</h4>
                    <p className="mt-2 text-gray-600">
                      Study seamlessly across devices, whether you're at home,
                      in a café, or on the move.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-12 lg:mt-0">
              <div className="relative rounded-2xl overflow-hidden shadow-xl">
                <AboutUsSvg2  />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Our Community Section */}
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900">Our Community</h2>
            <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
              CIVILSCODE is the sanctuary for every UPSC aspirant—from beginners
              to veterans, from cities to villages, we ensure complete
              preparation at everyone's fingertips.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="relative group">
              <div className="absolute inset-0 bg-[#77c36f] rounded-2xl opacity-0 group-hover:opacity-5 transition-opacity duration-300"></div>
              <div className="relative bg-white p-8 rounded-2xl shadow-lg group-hover:shadow-xl transition-all duration-300">
                <Users className="w-12 h-12 text-[#77c36f] mb-6" />
                <h3 className="text-xl font-semibold mb-4">
                  For Every Aspirant
                </h3>
                <p className="text-gray-600">
                  Whether you're taking your first step or aiming for the
                  zenith, find your path illuminated with us.
                </p>
              </div>
            </div>

            <div className="relative group">
              <div className="absolute inset-0 bg-[#77c36f] rounded-2xl opacity-0 group-hover:opacity-5 transition-opacity duration-300"></div>
              <div className="relative bg-white p-8 rounded-2xl shadow-lg group-hover:shadow-xl transition-all duration-300">
                <Globe className="w-12 h-12 text-[#77c36f] mb-6" />
                <h3 className="text-xl font-semibold mb-4">
                  Breaking Barriers
                </h3>
                <p className="text-gray-600">
                  Distance and location are no longer obstacles in your quest
                  for civil service excellence.
                </p>
              </div>
            </div>

            <div className="relative group">
              <div className="absolute inset-0 bg-[#77c36f] rounded-2xl opacity-0 group-hover:opacity-5 transition-opacity duration-300"></div>
              <div className="relative bg-white p-8 rounded-2xl shadow-lg group-hover:shadow-xl transition-all duration-300">
                <Target className="w-12 h-12 text-[#77c36f] mb-6" />
                <h3 className="text-xl font-semibold mb-4">Focused Success</h3>
                <p className="text-gray-600">
                  Transform your preparation into an engaging, enlightening
                  experience that propels you towards your goal.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Join Us Section */}
      <div className="bg-primary-color py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-8">
            Join the CIVILSCODE Odyssey
          </h2>
          <p className="text-xl text-white/90 mb-12 max-w-3xl mx-auto">
            Step into CIVILSCODE, where the journey to becoming a civil servant
            is transformed into an exhilarating quest. Let's navigate this
            journey together.
          </p>
          <button
            className="bg-white text-[#77c36f] px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl"
            onClick={() => navigate("/signup")}
          >
            Begin Your Journey
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
